import styles from "./styles.module.css";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReceiptsTable from "./receipts-table";
import ReceiptFilters from "./receipt-filters";

import { getTableRecords } from "../../Classes/API/ReceiptsApi";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const ReceiptPage = () => {
  const [searchParams] = useSearchParams();
  const [receipts, setReceipts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchReceipts() {
      try {
        setIsLoading(true);

        const filters = {};
        
        const patientName = searchParams.get("patientName");
        if (patientName) filters.patientName = patientName;

        const startDate = searchParams.get("startDate");
        if (startDate) filters.startDate = startDate;

        const endDate = searchParams.get("endDate");
        if (endDate) filters.endDate = endDate;

        const entryType = searchParams.get("entryType");
        if (entryType) filters.entryType = entryType;

        const page = searchParams.get("page");
        if (page) filters.page = page;

        const response = await getTableRecords(filters);
        setReceipts(response);
      } catch (error) {
        console.error("Error fetching receipts:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchReceipts();
  }, [searchParams]);

  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      <DashboardLayout>
        <DashboardNavbar />
        <div className={styles.container}>
          <h3>Receipts</h3>
          <ReceiptFilters />
          {isLoading ? (
            <p>Loading...</p>
          ) : receipts.items.length > 0 ? (
            <ReceiptsTable
              receipts={receipts.items}
              totalCount={receipts.totalCount}
              pageNumber={receipts.pageNumber}
              pageSize={receipts.pageSize}
            />
          ) : (
            <p>No receipts found.</p>
          )}
        </div>
      </DashboardLayout>
    </div>
  );
};

export default ReceiptPage;
